module.exports = __webpack_public_path__ + "f824712d0e578a7961e7a1315b7b885e.svg";